import mainCaller from './mainCaller';

// 센서가 오프라인이어도 장치로 보낼 때 (서버 연결 확인 생략)
const forceQuery = force => (force ? '?force=true' : '');

// 지점 IoT 매핑 정보 조회
export const getBranchIot = async (branchId, token) => {
  return await mainCaller(`admin/api/v1/iot/branch/${branchId}`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

// 전원 스케쥴 조회
export const getIotSchedule = async (branchId, roomId, token) => {
  return await mainCaller(`admin/api/v1/iot/schedule/${branchId}?roomId=${roomId}`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

// 센서 목록 조회
export const getIotSensor = async (branchId, token) => {
  return await mainCaller(`admin/api/v1/iot/sensor/${branchId}`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

// 도어 제어 (열기)
export const controlDoor = async (data, token, force = false) => {
  return await mainCaller(`admin/api/v1/iot/control/door${forceQuery(force)}`, 'POST', data, {
    Authorization: 'Bearer ' + token,
  });
};

// 룸 목록 조회
export const getIotRoom = async (branchId, token) => {
  return await mainCaller(`admin/api/v1/iot/room/${branchId}`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

// 센서 전원 상태 조회
export const getIotSensorStatus = async (sensorId, token) => {
  return await mainCaller(`admin/api/v1/iot/sensor/status/${sensorId}`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

// 전원 개별 제어 (조명 ON/OFF)
export const controlLight = async (data, token, force = false) => {
  return await mainCaller(`admin/api/v1/iot/control/light${forceQuery(force)}`, 'POST', data, {
    Authorization: 'Bearer ' + token,
  });
};

// 전원 전체 제어 (모든 조명 ON/OFF)
export const controlLightAll = async (data, token, force = false) => {
  return await mainCaller(`admin/api/v1/iot/control/light/all${forceQuery(force)}`, 'POST', data, {
    Authorization: 'Bearer ' + token,
  });
};

// 전원 스케줄 저장
export const saveIotSchedule = async (data, token, force = false) => {
  return await mainCaller(`admin/api/v1/iot/schedule${forceQuery(force)}`, 'POST', data, {
    Authorization: 'Bearer ' + token,
  });
};

// 센서 릴레이 설정 저장 (조명명 수정)
export const saveIotSensorRelays = async (data, token) => {
  return await mainCaller('admin/api/v1/iot/sensor/relays', 'POST', data, {
    Authorization: 'Bearer ' + token,
  });
};

// 센서 릴레이 목록 조회
export const getIotSensorRelays = async (sensorId, token) => {
  return await mainCaller(`admin/api/v1/iot/sensor/${sensorId}/relays`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

// 전원 예약 등록
export const createPowerReservation = async (data, token) => {
  return await mainCaller('admin/api/v1/iot/power-reservation', 'POST', data, {
    Authorization: 'Bearer ' + token,
  });
};

// 전원 예약 목록 조회 (지점 단위, 자식 예약 제외)
export const getPowerReservations = async (branchId, token) => {
  return await mainCaller(`admin/api/v1/iot/power-reservation/${branchId}`, 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

// 전원 예약 수정 (PENDING만)
export const updatePowerReservation = async (reservationId, data, token) => {
  return await mainCaller(`admin/api/v1/iot/power-reservation/${reservationId}`, 'PUT', data, {
    Authorization: 'Bearer ' + token,
  });
};

// 전원 예약 취소 (PENDING만)
export const cancelPowerReservation = async (reservationId, token) => {
  return await mainCaller(`admin/api/v1/iot/power-reservation/${reservationId}`, 'DELETE', null, {
    Authorization: 'Bearer ' + token,
  });
};

// === 총관리자 지점 IoT 연동 설정 ===

// Elyxion 지점 목록 (매핑 선택용)
export const getIotBranches = async token => {
  return await mainCaller('admin/api/v1/iot/branches', 'GET', null, {
    Authorization: 'Bearer ' + token,
  });
};

// 연동 설정: 매핑 + 룸·센서·릴레이 동기화
export const setupBranchIot = async (data, token) => {
  return await mainCaller('admin/api/v1/iot/branch/setup', 'POST', data, {
    Authorization: 'Bearer ' + token,
  });
};

// 재동기화
export const resyncBranchIot = async (branchId, token) => {
  return await mainCaller(`admin/api/v1/iot/branch/resync/${branchId}`, 'POST', null, {
    Authorization: 'Bearer ' + token,
  });
};

// 연동 해제 (룸·센서·릴레이·스케줄·전원예약 전부 삭제)
export const deleteBranchIot = async (branchId, token) => {
  return await mainCaller(`admin/api/v1/iot/branch/${branchId}`, 'DELETE', null, {
    Authorization: 'Bearer ' + token,
  });
};

// 전원 채널 묶음 제어 (조명 1~5 등). light/all 은 8채널 전부라 조명 전체에는 못 쓴다
export const controlLightChannels = async (data, token, force = false) => {
  return await mainCaller(`admin/api/v1/iot/control/light/channels${forceQuery(force)}`, 'POST', data, {
    Authorization: 'Bearer ' + token,
  });
};

// 도어 인증 가능 시간 등록 (회원 인증 허용 시간대, Elyxion 전송 후 branch_iot_room.DOOR_OPENING 저장)
export const registerDoorOpening = async (data, token, force = false) => {
  return await mainCaller(`admin/api/v1/iot/control/door/opening${forceQuery(force)}`, 'POST', data, {
    Authorization: 'Bearer ' + token,
  });
};
